import React, { Component } from "react";

import BootstrapTable from "react-bootstrap-table-next";

import { Link } from "react-router-dom";
import Dropzone from "react-dropzone";

import Modal from "react-responsive-modal";
import {
  Button,
  Form,
  FormGroup,
  Label,
  Col
} from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";

// koneksi
import { ID_DESA, JENIS_DESA, PostMain, GetMain, DeleteMain } from "../function/Koneksi";

// css files
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";

const frmInput = {
  uuid: '',
  id_desa: '',
  nama_surat: '',
  keterangan: '',
  file: '',
  link_gambar: '',
  status: '',
};

class BasicTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      pagination: [],
      status: {
        form: false,
        btnForm: false,
        btnAksi: false,
      },
      awal: "",
      sebelum: "",
      hal: [],
      setelah: "",
      akhir: "",
      statUbah: false,
      dt: frmInput,
      loading: false,
      loadingPreview: false,
      alert: null,
      show: false,
      basicTitle: "",
      basicType: "default",
      pesanAlert: "",
      // Cari Data
      dataCari: '',

      link_gambar: '',
      fileSuratDesa: '',
    };
  }

  // ================== Sweet Alert ==================
  closeAlert = () => {
    this.setState({
      show: false
    });
  };

  onRecieveInput = value => {
    this.setState({
      alert: (
        <SweetAlert success title="Nice!" onConfirm={this.hideAlert}>
          You wrote: {value}
        </SweetAlert>
      )
    });
  };

  hideAlert = () => {
    this.setState({
      alert: null
    });
  };

  // =================================================

  // ================== Ambil data dari db untuk table ==================
  fetch = (params = {}) => {
    this.setState({ loading: true })
    let link = "";

    if (params.page) {
      switch (params.page) {
        case ">>":
          link =
            "&page=" +
            Math.ceil(
              this.state.pagination.total / this.state.pagination.per_page
            );
          break;
        case ">":
          link = "&page=" + (parseInt(this.state.pagination.current_page) + 1);
          break;
        case "<":
          link = "&page=" + (parseInt(this.state.pagination.current_page) - 1);
          break;
        case "<<":
          link = "&page=1";
          break;
        default:
          link = "&page=" + params.page;
          break;
      }
    }

    let setLink = '';
    if (link) {
      setLink = `${link}&q=${this.state.dataCari}`
    }
    else {
      setLink = `?q=${this.state.dataCari}`
    }

    GetMain('main/web/request-surat' + setLink, null, (dtkat) => {
      console.log('Data Result')
      console.log(dtkat)
      if (dtkat.results) {
        this.setState({ data: dtkat.results.data, pagination: dtkat.results, loading: false });
        this.pagination(dtkat.results);
      }
      else {
        this.setState({ loading: false });
      }
    });
  };

  // Pagination
  pagination = data => {
    // const data = this.state.pagination; 
    let awal = "";
    let hal = [];
    let sebelum = "";
    let setelah = "";
    let akhir = "";
    if (data.total > 0) {
      let start = 1;
      let end = 5;
      let n = 0;
      let p = 0;
      if (data.current_page <= 3) {
        start = 1;
        end = 5;
        if (data.last_page > data.current_page) {
          n = data.current_page + 1;
        }
      } else {
        p = data.current_page - 1;
        n = data.current_page + 1;
        start = data.current_page - 2;
        end = data.current_page + 2;
      }
      if (end >= data.last_page - 2) {
        p = data.current_page - 1;
        if (start >= 5) {
          start = data.last_page - 4;
        }
        end = data.last_page;
      }

      for (let i = start; i <= end; i++) {
        let warna = "primary-custom";
        if (i === data.current_page) {
          warna = "danger";
        }
        hal.push(
          <a
            href={() => false}
            onClick={() => this.fetch({ page: i })}
            className={
              "btn btn-" + warna + " btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
            }
          >
            {i}
          </a>
        );
      }
      if (p > 0) {
        sebelum = (
          <a
            href={() => false}
            onClick={() => this.fetch({ page: p })}
            className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
          >
            {"<"}
          </a>
        );
      }
      if (n > 0) {
        setelah = (
          <a
            href={() => false}
            onClick={() => this.fetch({ page: n })}
            className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
          >
            {">"}
          </a>
        );
      }
      awal = (
        <a
          href={() => false}
          onClick={() => this.fetch({ page: 1 })}
          className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
        >
          {"<<"}
        </a>
      );
      akhir = (
        <a
          href={() => false}
          onClick={() => this.fetch({ page: data.last_page })}
          className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
        >
          {">>"}
        </a>
      );
    }
    this.setState({ awal, sebelum, hal, setelah, akhir });
  };

  // Cari Data Table
  cariData = e => {
    if (e.key === 'Enter') {
      this.setState({
        dataCari: e.target.value,
      });

      setTimeout(
        function () {
          this.fetch({ page: null, where: [] });
        }.bind(this),
        500
      );
    }
  }

  // ========================= upload file ======================================

  processGbr = (d) => {
    // //console.log(d[0].type);
    if (d.length === 1) {
      const tipefile = [
        "jpg", "jpeg", "png", "bmp", "tiff", "webp",
        "pdf", "doc", "docx", "xlsx", "xls"
      ];
      this.setState({ loading: true });
      let type = d[0].type.split("/");

      if (tipefile.includes(type[1]) || d[0].name.endsWith(".xlsx") || d[0].name.endsWith(".xls") || d[0].name.endsWith(".doc") || d[0].name.endsWith(".docx")) {
        let bodyFormData = new FormData();
        bodyFormData.append("file", d[0]);
        bodyFormData.append("folder", "Request Surat");
        bodyFormData.append("sub_folder", ID_DESA);
        bodyFormData.append("file_name", this.state.dt.nama_surat);

        PostMain("main/web/upload-file/store", null, bodyFormData, (data) => {
          // console.log(data);
          this.setState({
            link_gambar: data.data.results,
            fileSuratDesa: d[0].name,
            loading: false
          });
        },
          {
            "Content-Type": "multipart/form-data",
          }
        );
      } else {
        this.setState({
          loading: false,
          link_gambar: "",
          fileSuratDesa: "",
          foto_info: (
            <div className="text-danger font-size-10">
              Type file tidak valid
            </div>
          ),

          show: true,
          basicType: "danger",
          basicTitle: "Upload File",
          pesanAlert: "Format file tidak sesuai"
        });
      }
    } else {
      this.setState({
        link_gambar: "",
        fileSuratDesa: "",
        foto_info: (
          <div className="text-danger font-size-10">
            Silahkan masukan satu gambar atau dokumen
          </div>
        ),
      });
    }
  };

  // ================== simpan data ==================
  simpan = e => {
    this.setState({ loadingPreview: true })
    e.preventDefault();

    if (this.state.link_gambar || (this.state.dt.uuid && this.state.dt.file)) {

      let add = {
        uuid: this.state.dt.uuid,
        id_desa: this.state.dt.id_desa || ID_DESA,
        nama_surat: this.state.dt.nama_surat,
        keterangan: this.state.dt.keterangan,
        file: this.state.link_gambar,
        file_lama: this.state.dt.file,
        status: 'Pengajuan',
      };

      let psn = "";
      let resstat = 204;
      let metode = "create";
      if (add.uuid === "") {
        psn = "Tambah";
        resstat = 201;
        add.uuid = null;
      } else {
        psn = "Ubah";
        resstat = 200;
        metode = "update";
      }

      PostMain("main/web/request-surat/" + metode, add.uuid, add, res => {
        this.tutupForm();
        // this.forceUpdate();

        if (res.status === resstat) {
          this.setState({
            loadingPreview: false,
            show: true,
            basicType: "success",
            basicTitle: "Data Request Surat",
            pesanAlert: "Berhasil " + psn + " Data",
            dt: frmInput,
            status: {
              ...this.state.status,
              form: false
            }
          });
          this.resetForm();
        } else {
          this.setState({
            loadingPreview: false,
            show: true,
            basicType: "danger",
            basicTitle: "Data Request Surat",
            pesanAlert: "Gagal " + psn + " Data"
          });
        }
        this.componentDidMount();
      });

    }
    else {
      this.setState({
        loadingPreview: false,
        show: true,
        basicType: "danger",
        basicTitle: "Data Request Surat",
        pesanAlert: "Data Tidak Lengkap"
      });
    }
  };
  // ========================================================================

  // ============================== Ubah Data ===============================
  ubahData = data => {
    this.setState({
      loadingPreview: true,
      judul: "Ubah Data Request Desa " + JENIS_DESA,
    })

    if (data) {
      this.setState({
        link_gambar: JSON.parse(data.file),
        dt: {
          uuid: data.uuid,
          id_desa: data.id_desa,
          nama_surat: data.nama_surat,
          keterangan: data.keterangan,
          file: JSON.parse(data.file),
          status: 'Pengajuan',
        },
        status: {
          ...this.state.status,
          form: true
        },
        loadingPreview: false,
      })
    }
    else {
      this.setState({
        loadingPreview: false,
      })
    }
  };
  // ============================= Hapus Data ===============================
  konfirmHapus = id => {
    this.setState({
      alert: (
        <SweetAlert
          showCancel
          confirmBtnText="Hapus"
          confirmBtnBsStyle="danger"
          cancelBtnBsStyle="success"
          type="danger"
          title="Yakin ingin hapus data ?"
          onCancel={this.hideAlert}
          onConfirm={() => this.hapusData(id)}
        >
          Proses ini tidak dapat dibatalkan!
        </SweetAlert>
      )
    });
  };

  hapusData = id => {
    this.hideAlert();
    let psn = "Hapus";
    this.setState({
      loadingPreview: true,
    })
    DeleteMain("main/web/request-surat/delete", id, res => {
      if (res === 200) {
        this.setState({
          loadingPreview: false,
          show: true,
          basicType: "success",
          basicTitle: "Data Request Surat",
          pesanAlert: "Berhasil " + psn + " Data"
        });
        this.resetForm();
      } else {
        this.setState({
          loadingPreview: false,
          show: true,
          basicType: "danger",
          basicTitle: "Data Request Surat",
          pesanAlert: "Gagal " + psn + " Data"
        });
      }
      this.componentDidMount();
    });
  };
  // ========================================================================

  bukaForm = () => {
    this.setState({
      status: {
        ...this.state.status,
        form: true,
      },
    })
    this.forceUpdate();
  };

  tutupForm = () => {
    this.setState({
      status: {
        ...this.state.status,
        form: false,
      }
    })
    this.resetForm();
    this.forceUpdate();
  };

  resetForm = () => {
    this.setState({
      dt: frmInput,
      link_gambar: '',
      fileSuratDesa: '',
      status: {
        ...this.state.status,
        form: false,
        btnForm: false,
        btnAksi: false,
      }
    });
  };

  tombolAksi = (cell, row) => {
    let btnAksi = true;

    if (row.status === "Pengajuan") {
      btnAksi = false;
    } else {
      btnAksi = true;
    }
    return (
      <div>
        <Button
          size="xs"
          color="success"
          className="btn-icon mr-1"
          onClick={() => this.ubahData(row)}
          disabled={btnAksi}
        >
          <i className="fa fa-pencil"></i>
        </Button>
        <Button
          size="xs"
          color="danger"
          className="btn-icon"
          onClick={() => {
            this.setState({
              judul: "Hapus Jenis Surat",
              statReset: false
            });
            this.konfirmHapus(row.uuid)
          }}
          disabled={btnAksi}
        >
          <i className="fa fa-trash"></i>
        </Button>
      </div>
    );
  };

  changeSelectValue = (e, jenis) => {
    if (e) {
      this.setState({ [jenis]: e });
    } else {
      this.setState({ [jenis]: null });
    }
    this.forceUpdate();
  };


  handleChangeInputText = (e, parent) => {
    this.setState({
      dt: {
        ...this.state.dt,
        [parent]: e.target.value,
      }
    })
  };

  componentDidMount() {
    this.fetch({ page: null, where: [] });
  }

  render() {

    var data = this.state.data;

    const columns = [
      {
        dataField: "no",
        text: "No",
        headerAlign: 'center',
        align: 'center',
        formatter: (key, obj, index) => {
          let current_pagenum = this.state.pagination.current_page;
          let total_records_per_page = this.state.pagination.per_page;
          let row_index = (index + 1);
          let serial_num = ((total_records_per_page * (current_pagenum - 1)) + row_index);
          return serial_num;
        }
      },
      {
        dataField: "nama_surat",
        text: "Nama Surat",
        headerAlign: 'center',
        align: 'center',
        sort: true
      },
      {
        dataField: "keterangan",
        text: "Keterangan",
        headerAlign: 'center',
        align: 'center',
        sort: true
      },
      {
        dataField: "status",
        text: "Status",
        headerAlign: 'center',
        align: 'center',
        sort: true
      },
      {
        dataField: "aksi",
        text: "Aksi",
        headerAlign: 'center',
        align: 'center',
        formatter: this.tombolAksi
      }
    ];

    return (
      <div>
        {/* <Breadcrumb title="Penguna" parent="Admin" /> */}
        <SweetAlert
          show={this.state.show}
          type={this.state.basicType}
          title={this.state.basicTitle}
          confirmBtnBsStyle="success"
          onConfirm={this.closeAlert}
        >
          {this.state.pesanAlert}
        </SweetAlert>

        {this.state.alert}

        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card mb-0">
                <div className="card-header">
                  <div className="row">
                    <div className="col-sm-12">
                      <Link to={{ pathname: "/" }}>
                        <button color="info" className="btn btn-info mb-3"><i className="fa fa-arrow-left"></i> Kembali</button>
                      </Link>
                    </div>
                    <div className="col-sm-6">
                      <input
                        type="text"
                        className="form-control"
                        id="cariTable"
                        placeholder="Cari berdasarkan nama surat"
                        onKeyPress={this.cariData}
                      />
                    </div>
                    <div className="col-sm-6 text-right">
                      <Button
                        size="sm"
                        color="success"
                        className="btn-square"
                        onClick={() => {
                          this.setState({
                            judul: "Tambah Data Request Surat" + JENIS_DESA,
                            dt: frmInput,
                            link_gambar: '',
                            fileSuratDesa: "",
                          });
                          this.bukaForm();
                        }}
                      >
                        Tambah Data
                      </Button>
                    </div>
                  </div>
                </div>
                <div className="card-body datatable-react">
                  {this.state.loading ? (
                    <div className="row">
                      <div className="col-sm-12" align="center">
                        <img
                          alt="loading"
                          src={require("../assets/images/tes-loading.gif")}
                          style={{
                            borderRadius: "10px",
                            width: '100px'
                          }} />
                      </div>
                    </div>
                  ) : data.length > 0 ? (
                    <>
                      <BootstrapTable keyField="id" data={data} columns={columns} />
                      <div className="pull-right text-white">
                        {this.state.awal}
                        {this.state.sebelum}
                        {this.state.hal.map(dt => {
                          return dt;
                        })}
                        {this.state.setelah}
                        {this.state.akhir}
                      </div>
                    </>
                  ) : (
                    <h6 className="text-center mb-2 mt-2">Belum ada data</h6>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <br />
        {/* Loading preview */}
        <SweetAlert
          show={this.state.loadingPreview}
          showCancel={false}
          showConfirm={false}
        >
          <div align="center">
            <h5 className="modal-title" style={{ textAlign: "center", color: 'black' }}>Sedang memuat data...</h5>
            <br />
            <img
              alt="loading"
              src={require("../assets/images/tes-loading.gif")}
              style={{
                // width: "100%",
                borderRadius: "10px",
                width: '150px'
              }}
            />
            <br /><br />
          </div>
        </SweetAlert>
        <Modal
          size="lg"
          open={this.state.status.form}
          onClose={this.tutupForm}
          styles={{ modal: { width: "80%" } }}
          closeOnEsc={false}
          closeOnOverlayClick={false}
        >
          <div size="lg" className="modal-header">
            <h5 className="modal-title">{this.state.judul}</h5>
          </div>
          <Form className="theme-form" onSubmit={this.simpan}>
            <div className="modal-body">
              <input
                className="form-control"
                id="uuid"
                type="hidden"
                placeholder="uuid"
                defaultValue={this.state.dt.uuid}
              />
              <input
                className="form-control"
                id="id_desa"
                type="hidden"
                placeholder="id_desa"
                defaultValue={this.state.dt.id_desa}
              />
              <FormGroup className="row">
                <Label
                  className="col-sm-3 col-form-label"
                  htmlFor="inputEmail3"
                >
                  Nama Surat
                </Label>
                <Col sm="9">
                  <input
                    name="nama_surat"
                    className="form-control"
                    type="text"
                    placeholder={"Masukkan Nama Surat"}
                    value={this.state.dt.nama_surat}
                    onChange={e => this.handleChangeInputText(e, 'nama_surat')}
                    required
                  />
                </Col>
              </FormGroup>
              <FormGroup className="row">
                <Label
                  className="col-sm-3 col-form-label"
                  htmlFor="inputEmail3"
                >
                  Keterangan
                </Label>
                <Col sm="9">
                  <textarea
                    className="form-control"
                    id="keterangan"
                    placeholder="Keterangan Tentang Surat"
                    value={this.state.dt.keterangan}
                    onChange={e => this.handleChangeInputText(e, 'keterangan')}
                    required
                  />
                </Col>
              </FormGroup>
              <FormGroup className="row">
                <Label
                  className="col-sm-3 col-form-label"
                  htmlFor="inputEmail3"
                >
                  File
                </Label>
                <Col sm="9">
                  <input
                    className="form-control"
                    placeholder="File"
                    id="file_lama"
                    type="hidden"
                    defaultValue={this.state.dt.file}
                  />
                  <Dropzone
                    onDrop={(acceptedFiles) => this.processGbr(acceptedFiles)}
                    maxFiles={1}
                  >
                    {({ getRootProps, getInputProps }) => (
                      <section>
                        <div
                          {...getRootProps()}
                          style={{
                            minHeight: "100px",
                            paddingTop: "40px",
                            padding: "5px 5px 5px 5px",
                            border: "1px solid #d2d2d2",
                          }}
                        >
                          <input {...getInputProps()} />
                          <div
                            style={{
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <p className="text-center">
                              {this.state.loading ? (
                                <div className="row">
                                  <div className="col-sm-12" align="center">
                                    <img
                                      alt="loading"
                                      src={require("../assets/images/tes-loading.gif")}
                                      style={{
                                        borderRadius: "10px",
                                        width: '100px'
                                      }} />
                                  </div>
                                </div>
                              ) : this.state.link_gambar ? (
                                <img
                                  src={require("../assets/images/file-icon.png")}
                                  style={{
                                    width: '270px'
                                  }}
                                  alt=""
                                />
                              ) : (
                                <Label
                                  className="col-form-label text-center"
                                  htmlFor="inputEmail3"
                                >
                                  Drag 'n' drop some files here, or click to select files
                                </Label>
                              )}
                              {this.state.fileSuratDesa ? (
                                <div>{this.state.fileSuratDesa}</div>
                              ) : (
                                ""
                              )}
                            </p>
                          </div>
                        </div>
                      </section>
                    )}
                  </Dropzone>
                </Col>
              </FormGroup>

            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-warning"
                disabled={this.state.status.btnForm}
                onClick={this.tutupForm}
              >
                Tutup
              </button>
              <button
                type="submit"
                className="btn btn-success"
                disabled={this.state.status.btnForm}
              >
                Simpan
              </button>
            </div>
          </Form>
        </Modal>
      </div>
    );
  }
}

export default BasicTable;
